import { ReactElement } from 'react';
import { Button, Group, Paper, Text } from '@mantine/core';
import { IconBriefcase, IconDownload } from '@tabler/icons-react';

export function CarrumReportingBanner({ onExportCsv }: { onExportCsv: () => void }): ReactElement {
  return (
    <Paper withBorder p="sm" style={{ background: 'var(--mantine-color-yellow-0)' }}>
      <Group justify="space-between" wrap="nowrap">
        <Group gap="xs" wrap="nowrap">
          <IconBriefcase size={18} />
          <Text size="sm">
            <strong>Showing all Carrum-referred patients</strong> — weight outcomes and journey dates for partner
            reporting.
          </Text>
        </Group>
        <Group gap="xs" wrap="nowrap">
          <Button size="xs" variant="light" leftSection={<IconDownload size={14} />} onClick={onExportCsv}>
            Export CSV
          </Button>
          <Button size="xs" variant="subtle" color="gray" disabled title="Coming soon (BAR-2336)">
            Partner report
          </Button>
        </Group>
      </Group>
    </Paper>
  );
}
